var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "Script-2--Streamline-Plump",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Script 2 Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "script-2--language-programming-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 36.3529c0.3697 6.1654 -2.5 7.4118 -4 7.4118C3 43.7647 9.5 45 19 45c4.4849 0 8.3011 -0.2753 11.0805 -0.566 2.8661 -0.2997 4.9294 -2.7553 4.8495 -5.6359C34.6912 30.1945 33.9035 22.81 33.5424 13c-0.1126 -3.06039 0 -9 4.4576 -10L12 3C8.68629 3 6.00548 5.68197 6.05053 8.99537 6.13668 15.3307 6.3697 25.8418 7 36.3529Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m37.9996 3.00001 1 -0.00001c3.0001 0 6 2.19512 6 6.09756v0.6487c0 1.34664 -0.9034 2.50194 -2.2369 2.68934 -1.8227 0.2562 -4.8214 0.5412 -9.2207 0.5631",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1679",
    stroke: "#000000",
    strokeLinecap: "round",
    d: "M17 13h10",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1680",
    stroke: "#000000",
    strokeLinecap: "round",
    d: "m13 20 14 0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1681",
    stroke: "#000000",
    strokeLinecap: "round",
    d: "m13.5 27 14 0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1682",
    stroke: "#000000",
    strokeLinecap: "round",
    d: "m14 34 14 0",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/article-icon.c2819f632c0232f6f1818f5706a9f156.svg";
export { ForwardRef as ReactComponent };